export default __webpack_public_path__ + "static/media/logo-chrome.a42815a0.svg";